<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_vii"></a><a id="cont"></a></p>
<h2 class="h2a">Contents</h2>
<p class="tocfront"><a class="nounder" href="#/xhtml/ack#ack"><em>Acknowledgments</em></a></p>
<p class="tocfront"><a class="nounder" href="#/xhtml/not#not"><em>Note on Translations</em></a><br/><br/></p>
<p class="tocfront"><a class="nounder" href="#/xhtml/intro#intro">  Introduction</a></p>
<p class="tocchap"><a class="nounder" href="#/xhtml/ch01#ch01">1    Hinduism</a></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">2    Chinese Religions</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3    Buddhism</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4    Religions of the Fertile Crescent</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5    Religions of Ancient Greece and Rome</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6    Christianity</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">7    Islam</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">8    Religions of Africa</span></p>
<p class="tocchap"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">9    Religions of Oceania</span></p>
<p class="tocchap1"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">10    Religions of the Americas</span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/conc#conc" title="Link target outside of Sample">Conclusion</span><br/><br/></p>
<p class="tocback"><span class="nounder" href="#/xhtml/notes#notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/bib#bib" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="tocback"><span class="nounder" href="#/xhtml/ata#ata" title="Link target outside of Sample"><em>About the Author</em></span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7c9bb438